// extracted by mini-css-extract-plugin
export var danger = "_3l-6";
export var lightPink = "_3l-a";
export var medium = "_3l-j";
export var nearSquare = "_3l-m";
export var neutralBlue = "_3l-8";
export var neutralYellow = "_3l-7";
export var noCapitalize = "_3l-1";
export var normal = "_3l-2";
export var pill = "_3l-0";
export var primary = "_3l-3";
export var primaryLight = "_3l-4";
export var shadow = "_3l-n";
export var small = "_3l-k";
export var solidBlack = "_3l-i";
export var solidGreen = "_3l-d";
export var solidLightBlue = "_3l-f";
export var solidNavy = "_3l-e";
export var solidOrange = "_3l-h";
export var solidPink = "_3l-g";
export var solidRed = "_3l-b";
export var solidWhite = "_3l-9";
export var solidYellow = "_3l-c";
export var success = "_3l-5";
export var xsmall = "_3l-l";